<template>
  <router-view />
</template>

<script>
export default {
  name: "self-index",
};
</script>

<style>
</style>